import { render } from "./PanelPricingButtonAndModal.vue?vue&type=template&id=56a3d4c1&scoped=true"
import script from "./PanelPricingButtonAndModal.vue?vue&type=script&lang=js"
export * from "./PanelPricingButtonAndModal.vue?vue&type=script&lang=js"

import "./PanelPricingButtonAndModal.vue?vue&type=style&index=0&id=56a3d4c1&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a3d4c1"]])

export default __exports__